import { useQuestions } from "src/context/QuestionsProvider";

export const useGetNextFromOptions = (answers: string[]) => {
  const questionOptions = useQuestions((q) => q.options);
  if (questionOptions == null) return undefined;

  const options = questionOptions.find(
    (option) => answers.includes(option.value) && option.next_question != null,
  );

  return options?.next_question;
};
